// @flow

import 'firebase/auth'
import 'firebase/database'
import './index.less'

import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Form, Input } from 'antd'
import { RouterHistory } from 'react-router-dom'
import { signInWithFacebook, signInWithGoogle } from '~utils/social'
import { LOGIN_USER } from '~state/user/queries'
import { store } from 'react-notifications-component'
import firebase from 'firebase/app'
import moment from 'moment'
import Cookies from 'js-cookie'
import Button from '~button'
import Facebook from '~images/facebook-login.svg'
import Google from '~images/google-login.svg'
import { noDataProvided, notAgree, alreadyExist, weekPassword, success } from './registerNotifications'
import client from '../../services/api'

type PropsType = {
  history: RouterHistory,
  onRegister?: Function
}

const RegisterForm = ({ history, onRegister }: PropsType) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [login, setLogin] = useState(null)
  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)
  const [recovery, setRecovery] = useState(null)
  const [recoveryEmail, setRecoveryEmail] = useState(null)
  const [fname, setFName] = useState(null)
  const [agree, setAgree] = useState(false)
  const [disabledRegisterBtn, setDisabled] = useState(true)
  const [agreePolitics, setAgreePolitics] = useState(false)
  const [agreeMarketing, setAgreeMarketing] = useState(false)
  const [isLogin, setIsLogin] = useState(null)
  const domain = process.env.NODE_ENV === 'development' ? 'localhost' : '.mudey.pt'

  let mailformat = /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
  useEffect(() => {
    if (email && password && email.match(mailformat) && fname && agree === true && agreePolitics === true) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [email, password, fname, agree, agreePolitics, agreeMarketing])
  const loginAfterRegistration = async () => {
    try {
      setIsLoading(true)
      dispatch({ type: 'LOADING' })
      const user = firebase.auth().currentUser
      if (user) {
        const token = await user.getIdToken()
        Cookies.set('MUDEY_token', token, { domain: domain }, { expires: 1 }, { sameSite: 'strict' }, { secure: true })
        Cookies.set(
          'MUDEY_uuid',
          user.uid,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        Cookies.set(
          'MUDEY_email',
          user.email,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )

        const companyId = Cookies.get('MUDEY_company', { domain: domain }) || 'Mudey'
        const managerId = Cookies.get('MUDEY_manager', { domain: domain }) || ''
        const consents = {
          privacyConsent: true,
          insuranceConsent: true,
          marketingConsent: agreeMarketing,
          createdAt: moment().format(),
          updatedAt: ''
        }

        const { data } = await client.query({
          query: LOGIN_USER,
          fetchPolicy: 'no-cache',
          variables: {
            companyId: companyId,
            managerId: managerId,
            consents: consents
          }
        })
        Cookies.set(
          'MUDEY_name',
          data.userLogin.firstName,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        Cookies.set(
          'MUDEY_company',
          data.userLogin.companyId,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        Cookies.set(
          'MUDEY_manager_handler',
          data.userLogin.managerId,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        await dispatch({
          type: 'LOGIN',
          payload: {
            token,
            user: {
              email: user.email,
              name: data.userLogin.firstName,
              uuid: user.uid
            }
          }
        })
      }
    } catch (error) {
      setIsLoading(false)
    }
  }
  const register = () => {
    setDisabled(true)
    if (!email || !password || !fname) {
      store.addNotification(noDataProvided)
      return false
    }

    if (!agree || !agreePolitics) {
      store.addNotification(notAgree)

      return false
    }

    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(async () => {
        const user = firebase.auth().currentUser

        user.updateProfile({
          displayName: fname
        })
        await loginAfterRegistration()
        store.addNotification(success)
        onRegister && onRegister()
      })
      .catch((error: Object) => {
        switch (error.code) {
          case 'auth/email-already-in-use':
            store.addNotification(alreadyExist)
            setIsLoading(false)
            break
          case 'auth/weak-password':
            store.addNotification(weekPassword)
            setIsLoading(false)
            break
        }
        setDisabled(false)
      })
  }

  return (
    <div className="container__register">
      <div className="container-register">
        <Form>
          <Form.Item label="Primeiro Nome">
            <Input
              name="first-name"
              onChange={(v: any) => {
                setFName(v.target.value)
              }}
              placeholder="Primeiro Nome"
            />
          </Form.Item>
          <Form.Item label="Email">
            <Input
              name="email"
              onChange={(v: any) => {
                setEmail(v.target.value)
              }}
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item label="Palavra Passe">
            <Input.Password
              name="password"
              onChange={(v: any) => {
                setPassword(v.target.value)
              }}
              placeholder="Palavra Passe"
              type="password"
            />
          </Form.Item>

          <div className="data-div">
            <input
              className="regular-checkbox"
              id="agree"
              onChange={(v: any) => {
                setAgree(v.target.checked)
              }}
              type="checkbox"
            />
            <label className="agree_label" htmlFor="agree">
              <div className={agree ? 'ellipsis active' : 'ellipsis'} />
              Li e concordo com as{' '}
              <a
                href={`${process.env.REACT_APP_HP_URL || ''}/politica-de-privacidade/`}
                rel="noopener noreferrer"
                target="_blank">
                Políticas de Dados
              </a>{' '}
              e de{' '}
              <a
                href={`${process.env.REACT_APP_HP_URL || ''}/termos-e-condicoes/`}
                rel="noopener noreferrer"
                target="_blank">
                Condições de Uso
              </a>{' '}
              do Website da MUDEY
            </label>
          </div>

          <div className="data-div">
            <input
              className="regular-checkbox"
              id="agree_politics"
              onChange={(v: any) => {
                setAgreePolitics(v.target.checked)
              }}
              type="checkbox"
            />
            <label className="agree_label" htmlFor="agree_politics">
              <div className={agreePolitics ? 'ellipsis active' : 'ellipsis'} />
              Autorizo a MUDEY a tratar os meus dados para obter informações sobre seguros e gestão dos meus seguros
            </label>
          </div>

          <div className="data-div">
            <input
              className="regular-checkbox"
              id="agree_marketing"
              onChange={(v: any) => {
                setAgreeMarketing(v.target.checked)
              }}
              type="checkbox"
            />
            <label className="agree_label" htmlFor="agree_marketing">
              <div className={agreeMarketing ? 'ellipsis active' : 'ellipsis'} />
              Autorizo a MUDEY a enviar-me informações de poupança, newsletters, ações promocionais e passatempos.
            </label>
          </div>

          <Form.Item>
            <Button
              disabled={disabledRegisterBtn}
              color="purple"
              onClick={register}
              style={{
                background: disabledRegisterBtn ? '#dedede' : null
              }}
              type="button">
              Registar
            </Button>
          </Form.Item>
          <div className="google-container">
            <span className="google social" onClick={signInWithGoogle}>
              <img src={Google} />
            </span>
            <span className="facebook social" onClick={signInWithFacebook}>
              <img src={Facebook} />
            </span>
          </div>
        </Form>
      </div>
    </div>
  )
}

RegisterForm.defaultProps = {
  onRegister: () => true
}

export default RegisterForm
